import * as React from "react"; // eslint-disable-next-line
import { useSelector } from "react-redux";
import { Outlet } from "react-router-dom";

// CSS
import "./artifacts/css/core.css";
import "./artifacts/css/theme-default.css";
import "./artifacts/css/layout.css";
import "./artifacts/css/spinner.css";

// Components
import Menu from "../Components/Menu";
import UserNav from "../Components/NavBar/UserNav";
import Burger from "../Components/NavBar/Burger";
import NewLayout from "../../components/NewLayout";


export default function Layout() {
	const { pageTitle } = useSelector(
		(rootReducer) => rootReducer.layoutDataReducer
	);

	// Use new layout for now - can be toggled back to old layout
	const useNewLayout = true;

	if (useNewLayout) {
		return <NewLayout />;
	}

	return (
		<>
			<div className="layout-wrapper layout-content-navbar">
				<div className="layout-container">
					{/* <!-- Menu --> */}
					<Menu />
					{/* <!-- / Menu --> */}

					{/* <!-- Layout container --> */}
					<div className="layout-page">
						{/* <!-- Navbar --> */}

						<nav
							className="layout-navbar container-xxl navbar navbar-expand-xl navbar-detached align-items-center bg-navbar-theme"
							id="layout-navbar"
						>
							<Burger />

							<div
								className="navbar-nav-right d-flex align-items-center"
								id="navbar-collapse"
							>
								{/* <!-- Search --> */}
								<div className="navbar-nav align-items-center">
									<div className="nav-item d-flex align-items-center">
										<h4 className="fw-bold" style={{marginBottom:'0px'}}>
											<span className="text-muted fw-light">{pageTitle}</span>
										</h4>
									</div>
								</div>
								{/* <!-- /Search --> */}
								<UserNav />
							</div>
						</nav>

						{/* <!-- / Navbar --> */}

						{/* <!-- Content wrapper --> */}
						<div className="content-wrapper" >
							{/* <!-- Content --> */}
							<Outlet />

							{/* <!-- / Content --> */}

							<div className="content-backdrop fade"></div>
						</div>
						{/* <!-- Content wrapper --> */}
					</div>
					{/* <!-- / Layout page --> */}
				</div>

				{/* <!-- Overlay --> */}
				<div className="layout-overlay layout-menu-toggle"></div>
			</div>
		</>
	);
}
